import ky from 'ky';

const kyOriginal = ky.create({
  timeout: 600000,
});

export default kyOriginal;
